import { render, staticRenderFns } from "./LoadNew.vue?vue&type=template&id=0e3b66cb&scoped=true"
import script from "./LoadNew.vue?vue&type=script&lang=js"
export * from "./LoadNew.vue?vue&type=script&lang=js"
import style0 from "./LoadNew.vue?vue&type=style&index=0&id=0e3b66cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3b66cb",
  null
  
)

export default component.exports